export const imageURL = {
    methods: {
        imageURL(url) {
            if (url.startsWith("blob")) {
                return url;
            }
            return process.env.VUE_APP_BACKEND_URL + "/storage/" + url;
        },
    },
};
